// extracted by mini-css-extract-plugin
export var interactive = "styles-module--interactive--9f64a";
export var tag = "styles-module--tag--2febb";